import { forwardRef, type InputHTMLAttributes } from "react";

export type InputProps = InputHTMLAttributes<HTMLInputElement>;

const Input = forwardRef<HTMLInputElement, InputProps>(function Input({ className = "", ...props }, ref) {
    return <input {...props} ref={ref} className={`h-10 w-full rounded-md border border-slate-300 bg-white px-3 text-sm text-slate-700 outline-none focus:border-[#005fb8] focus:ring-2 focus:ring-[#005fb8]/20 disabled:cursor-not-allowed disabled:bg-slate-100 disabled:text-slate-400 ${className}`.trim()} />;
});

export default Input;
